export class Payment {
	paymentid: number;
	poreferenceid: number;
	invoicereferenceid: number;
	paymentMode: string;
	paymentreferenceno: string;
	amount: number;
	paymentdate: Date;	
	active: number;	
    createon: Date;
	createdby:number;	
    modifiedon: Date;	
    modifiedby: number;
	
}